















































































































































































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Calendar from "../general/Calendar.vue";
import PointerMenu from "../general/PointerMenu.vue";
import Loading from "../general/Loading.vue";

import CalendarUtils from "../../shared/CalendarUtils";
import CalendarEventJson from "../../shared/CalendarEventJson";

import RentalBookingJson, {
  defaultRentalBookingJson,
  getRentalBookingTotalPrice,
} from "../../shared/RentalBookingJson";
import { RentalItemInfoJson } from "../../shared/RentalItemJson";
import { RentalBookingStatus, RentalBookingStatusNames } from "../../shared/RentalBookingStatus";
import RentalBookingInfoJson from "../../shared/RentalBookingInfoJson";
import CategoryTypeJson from "../../shared/CategoryTypeJson";
import CustomerJson from "../../shared/CustomerJson";
import SepaMandateJson from "../../shared/SepaMandateJson";
import { Gender } from "../../shared/Gender";
import PriceUtils from "../../shared/PriceUtils";

import SettingsJson from "../../shared/SettingsJson";
import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { ValidationResult, Validation } from "../../shared/Validation";
import { validateRentalBookingJson, validateRentalBookingJsonAdd } from "../../shared/RentalBookingJson";
import FormSepaMandate from "../general/FormSepaMandate.vue";
import RentalItemJson from "../../shared/RentalItemJson";
import RentalConditionJson, {
  defaultRentalConditionJson,
  getRentalConditionPrice,
} from "../../shared/RentalConditionJson";

type keysForCachedPrices = {
  [key in keyof Pick<RentalConditionJson, "price" | "cancellationFee">]: string;
};

export default Vue.extend({
  name: "RentalBookingPeriodSelect",
  components: {
    Calendar,
    PointerMenu,
    Loading,
    FormSepaMandate,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    restrictToTypeId: Number as PropType<number | null>,
    productIndex: Number,
    data: Object,
    clientData: Object,
    isPublic: Boolean,
    editable: Boolean,
    validation: Object,
    submitValidation: Boolean,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      Gender: Gender,
      PriceUtils: PriceUtils,
      CalendarUtils: CalendarUtils,
      RentalBookingDefaultData: defaultRentalBookingJson(),
      RentalBookingStatus: RentalBookingStatus,
      RentalBookingStatusNames: RentalBookingStatusNames,
      supportsDatePicker: false,
      UserPermissionRank: UserPermissionRank,
      rentalBookingInfo: null as RentalBookingInfoJson | null,
      rentalItemInfo: null as RentalItemInfoJson | null,
      details: null as RentalBookingJson | null,
      cachedPrices: {} as keysForCachedPrices,
      manualBeginDate: "" as string,
      manualEndDate: "" as string,
      availableAmounts: null as { [index: string]: { open: boolean; contactlessReturn: boolean; amount: number } } | null,
      availableConditions: null as RentalConditionJson[] | null,
      availablePickupDates: null as string[] | null,
      availableReturnDates: null as string[] | null,
      availableEventsBegin: null as CalendarEventJson[] | null,
      availableEventsEnd: null as CalendarEventJson[] | null,
      dateToShowBegin: null as Date | null,
      dateToShowEnd: null as Date | null,
      currentBeginCalenderYearMonth: null as [number, number] | null,
      currentEndCalenderYearMonth: null as [number, number] | null,
      currentCalendarDateIsSet: true as boolean,
      showBeginCalendar: true as boolean,
      showEndCalendar: false as boolean,
      editableDate: false as boolean,
      hasChanges: false,
      hintChanged: {
        state: false as boolean,
      },
      toValidate: {} as any,
      compValidation: null as ValidationResult<RentalBookingJson> | null,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.initDetails();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    async initDetails() {
      this.details = this.data;

      this.setCachedData();
      await this.loadRentalBookingInfo();
      await this.loadRentalItemInfo();
      await this.loadRentalItemAvailableConditions();
    },

    setCachedData() {
      this.setCachedPrices();

      this.$nextTick(() => {
        this.hasChanges = false;
      });
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    async loadRentalBookingInfo() {
      this.rentalBookingInfo = null;

      let rc = RestClient;
      try {
        this.rentalBookingInfo = await rc.getRentalBookingInfo();
      } catch (e) {
        alert(e.message);
      }
    },

    async loadRentalItemInfo() {
      if (this.details != null && this.details.rentalItem != null && this.details.rentalItem.ID != null) {
        this.rentalItemInfo = null;

        let rc = RestClient;
        try {
          this.rentalItemInfo = await rc.getRentalItemInfo(this.details.rentalItem.ID);
        } catch (e) {
          alert(e.message);
        }
      }
    },

    //START set cached data

    setCachedPrices() {
      if (this.details != null && this.details.rentalCondition != null) {
        this.cachedPrices = {
          price: this.getFormatPrice(this.details.rentalCondition.price),
          cancellationFee: this.getFormatPrice(this.details.rentalCondition.cancellationFee),
        };
      }
    },

    //END set cached data

    showEditableDate() {
      if (this.editable) {
        let c = confirm(
          "Bei der manuellen Datums-Änderung prüft das System keine Verfügbarkeiten und Öffnungstage. Diese Prüfung müssen Sie selbst durchführen.\n\nWollen Sie wirklich fortfahren?"
        );
        if (c == true) {
          this.editableDate = true;
        }
      }
    },

    showCurrentCalendarMonth() {
      if (this.details != null) {
        if (this.details.beginDate != "") {
          this.manualBeginDate = this.details.beginDate;
          this.jumpToDateInBeginCal(new Date(this.details.beginDate));
          this.currentCalendarDateIsSet = true;
        }

        if (this.details.endDate != "") {
          this.manualEndDate = this.details.endDate;
          this.jumpToDateInEndCal(new Date(this.details.endDate));
          this.currentCalendarDateIsSet = true;
        }
      }
    },

    resetBeginAndEnd() {
      if (this.details != null) {
        this.showEndCalendar = false;

        this.details.beginDate = "";
        this.details.endDate = "";

        this.manualBeginDate = "";
        this.manualEndDate = "";

        this.availableAmounts = null;
        this.resetBeginCalendarEntries();
        this.resetEndCalendarEntries();
      }
    },

    resetBeginCalendarEntries() {
      this.availablePickupDates = null;
      this.availableEventsBegin = null;
    },

    resetEndCalendarEntries() {
      this.availableReturnDates = null;
      this.availableEventsEnd = null;
    },

    async setBeginDateManual() {
      if (this.isValidDate(new Date(this.manualBeginDate))) {
        await this.setBeginDate(this.manualBeginDate);

        this.$nextTick(() => {
          this.jumpToDateInBeginCal(new Date(this.manualBeginDate));
        });

        //await this.loadBeginAvailabilities();
      }
    },

    async setBeginDate(dateString: string) {
      if (this.details != null && this.availableEventsBegin != null) {
        if (this.checkSelectableCalendarEventAtDate(this.availableEventsBegin, dateString) || this.editableDate) {
          this.details.beginDate = dateString;
          this.manualBeginDate = dateString;
          this.details.endDate = "";
          this.manualEndDate = "";

          this.details.rentalCondition = { ...defaultRentalConditionJson() };
          this.availableConditions = null;

          this.showEndCalendar = true;

          this.$nextTick(() => {
            this.jumpToDateInEndCal(new Date(dateString));
          });

          //await this.loadEndAvailabilities();
        }
      }
    },

    async setEndDateManual() {
      if (this.isValidDate(new Date(this.manualEndDate))) {
        await this.setEndDate(this.manualEndDate);
      }
    },

    async setEndDate(dateString: string) {
      if (this.details != null && this.availableEventsEnd != null) {
        if (this.checkSelectableCalendarEventAtDate(this.availableEventsEnd, dateString) || this.editableDate) {
          this.details.endDate = dateString;
          this.manualEndDate = dateString;

          this.details.rentalCondition = { ...defaultRentalConditionJson() };

          await this.loadRentalItemAvailableConditions();
        }
      }
    },

    checkSelectableCalendarEventAtDate(events: CalendarEventJson[], date: string) {
      let event = events.find((i) => i.beginDateTime.split("T")[0] == date);

      if (event !== undefined) {
        if (event.eventData.selectable && event.state == "available") {
          return true;
        } else {
          if (event.state == "overbooked") {
            alert("Verfügbare Anzahl nicht ausreichend (" + event.eventData.amount + " verfügbar)");
          }
          return false;
        }
      }
    },

    async loadAvailabilities() {
      await this.loadBeginAvailabilities();
      await this.loadEndAvailabilities();
    },

    async loadBeginAvailabilities() {
      if (this.currentBeginCalenderYearMonth != null) {
        var today = new Date();

        if (
          this.currentBeginCalenderYearMonth[0] == today.getFullYear() &&
          this.currentBeginCalenderYearMonth[1] == today.getMonth()
        ) {
          var from = today;
        } else {
          var from = new Date(this.currentBeginCalenderYearMonth[0], this.currentBeginCalenderYearMonth[1], 1);
        }

        var to = new Date(this.currentBeginCalenderYearMonth[0], this.currentBeginCalenderYearMonth[1] + 1, 0);

        //if (from.getTime() >= today.getTime() || !this.isPublic) {
        //await this.loadRentalItemAvailablePickupDays(from, to);
        await this.loadRentalItemAvailableDayAmounts(from, to);

        this.availableEventsBegin = this.getAvailabilityEvents(this.getBeginCalendarData());
        //}
      }
    },

    async loadEndAvailabilities() {
      if (this.currentEndCalenderYearMonth != null && this.details != null) {
        var beginDate = new Date(this.details.beginDate);

        if (
          this.currentEndCalenderYearMonth[0] == beginDate.getFullYear() &&
          this.currentEndCalenderYearMonth[1] == beginDate.getMonth()
        ) {
          var from = new Date(beginDate.setDate(beginDate.getDate()));
        } else {
          var from = new Date(this.currentEndCalenderYearMonth[0], this.currentEndCalenderYearMonth[1], 1);
        }

        var to = new Date(this.currentEndCalenderYearMonth[0], this.currentEndCalenderYearMonth[1] + 1, 0);

        //if (from.getTime() >= beginDate.getTime() || !this.isPublic) {
        //await this.loadRentalItemAvailableReturnDays(beginDate, to);
        await this.loadRentalItemAvailableDayAmounts(from, to);

        this.availableEventsEnd = this.getAvailabilityEvents(this.getEndCalendarData());
        //}
      }
    },

    async loadRentalItemAvailableDayAmounts(from: Date, to: Date) {
      if (this.details != null && this.details.rentalItem != null && this.details.rentalItem.ID != null) {
        if (this.isValidDate(from) && this.isValidDate(to)) {
          this.availableAmounts = null;

          let rc = RestClient;
          try {
            this.availableAmounts = await rc.getRentalItemAvailableDayAmounts(
              this.details.rentalItem.ID,
              from,
              to,
              this.permissionAble,
              this.details.ID
            );
          } catch (e) {
            alert(e.message);
          }
        }
      }
    },

    async loadRentalItemAvailableConditions() {
      if (
        this.details != null &&
        this.details.rentalItem != null &&
        this.details.rentalItem.ID != null &&
        this.details.beginDate &&
        this.details.endDate
      ) {
        this.availableConditions = null;

        let rc = RestClient;
        try {
          this.availableConditions = await rc.getRentalItemAvailableConditions(
            this.details.rentalItem.ID,
            this.details.amount,
            new Date(this.details.beginDate),
            new Date(this.details.endDate),
            this.permissionAble,
            this.details.ID
          );
        } catch (e) {
          alert(e.message);
        }
      }
    },

    /* async loadRentalItemAvailablePickupDays(from: Date, to: Date) {
      if (this.details != null && this.details.rentalItem != null && this.details.rentalItem.ID != null) {
        if (this.isValidDate(from) && this.isValidDate(to)) {
          this.availablePickupDates = null;

          let rc = RestClient;
          try {
            this.availablePickupDates = await rc.getRentalItemAvailablePickupDays(
              this.details.rentalItem.ID,
              this.details.rentalCondition.title,
              this.details.amount,
              from,
              to,
              this.permissionAble,
              this.details.ID
            );
          } catch (e) {
            alert(e.message);
          }
        }
      }
    }, */

    /* async loadRentalItemAvailableReturnDays(from: Date, to: Date) {
      if (this.details != null && this.details.rentalItem != null && this.details.rentalItem.ID != null) {
        if (this.isValidDate(from) && this.isValidDate(to)) {
          this.availableReturnDates = null;

          let rc = RestClient;
          try {
            this.availableReturnDates = await rc.getRentalItemAvailableReturnDays(
              this.details.rentalItem.ID,
              this.details.rentalCondition.title,
              this.details.amount,
              from,
              to,
              this.permissionAble,
              this.details.ID
            );
          } catch (e) {
            alert(e.message);
          }
        }
      }
    }, */

    getBeginCalendarData() {
      var data = [];

      if (this.details != null && this.availableAmounts != null) {
        let item: any;
        for (item in this.availableAmounts) {
          let dataItem = {
            date: "",
            availability: "",
            selectable: false,
            amount: 0,
          };

          let selectableStatus = false;

          let availabilityStatus = this.getAvailabilityStatus(this.details.amount, this.availableAmounts[item].amount);
          selectableStatus = availabilityStatus == "available" ? true : false;

          dataItem.date = item;
          dataItem.availability = availabilityStatus;
          dataItem.selectable = selectableStatus && this.availableAmounts[item].open;
          dataItem.amount = this.availableAmounts[item].amount;

          data.push(dataItem);
        }
      }

      return data;
    },

    getEndCalendarData() {
      var data = [];

      if (this.details != null && this.availableAmounts != null) {
        let selectableStatus = true;

        let item: any;
        for (item in this.availableAmounts) {
          let dataItem = {
            date: "",
            availability: "",
            selectable: false,
            amount: 0,
          };

          let availabilityStatus = this.getAvailabilityStatus(this.details.amount, this.availableAmounts[item].amount);
          selectableStatus = availabilityStatus == "available" && selectableStatus ? true : false;

          dataItem.date = item;
          dataItem.availability = availabilityStatus;
          dataItem.selectable = selectableStatus && (this.availableAmounts[item].open || this.availableAmounts[item].contactlessReturn);
          dataItem.amount = this.availableAmounts[item].amount;

          data.push(dataItem);
        }
      }

      return data;
    },

    getAvailabilityEvents(data: any[]) {
      var events: CalendarEventJson[] = [];

      for (let item of data) {
        let event: CalendarEventJson = {
          title: "",
          beginDateTime: "",
          endDateTime: "",
          state: "",
          eventData: {},
        };

        event.title = "";
        event.beginDateTime = item.date + "T" + "09:00:00";
        event.endDateTime = item.date + "T" + "17:00:00";
        event.state = item.availability;

        event.eventData = {
          selectable: item.selectable,
          amount: item.amount,
        };

        events.push(event);
      }

      return events;
    },

    getAvailabilityStatus(amount: number, availableAmount: number) {
      if (availableAmount <= 0) {
        return "booked";
      } else if (amount <= availableAmount) {
        return "available";
      } else {
        return "overbooked";
      }
    },

    /* inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.details != null) {
        this.validation = validateRentalBookingJson(this.details);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    }, */

    //START set input data (where data be cached)

    formatAndSetCachedPrice(key: keyof keysForCachedPrices) {
      if (this.details != null && this.details.rentalCondition != null) {
        let price = this.cachedPrices[key].replace(".", ",");

        if (!price.includes(",")) {
          price += ",00";
        }

        if (!price.match(/^\d{1,}(,\d{2})?$/)) {
          price = "";
        }

        this.cachedPrices[key] = price;
        this.details.rentalCondition[key] = parseInt(price.replace(/[\D]/g, ""));
      }
    },

    //END set input data (where data be cached)

    /* Calendar START */

    calenderBeginCurrentYearMonth(year: number, month: number) {
      this.resetBeginCalendarEntries();

      this.currentBeginCalenderYearMonth = [year, month];
      if (this.currentCalendarDateIsSet) {
        this.loadBeginAvailabilities();
      }
    },

    calenderEndCurrentYearMonth(year: number, month: number) {
      this.resetEndCalendarEntries();

      this.currentEndCalenderYearMonth = [year, month];
      if (this.currentCalendarDateIsSet) {
        this.loadEndAvailabilities();
      }
    },

    jumpToDateInBeginCal(date: Date) {
      this.dateToShowBegin = date;
    },

    jumpToDateInEndCal(date: Date) {
      this.dateToShowEnd = date;
    },

    /* Calendar END */

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.details != null) {
        this.compValidation = validateRentalBookingJson(this.details);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    isValidDate(dateToTest: Date) {
      if (dateToTest.getTime()) {
        return true;
      } else {
        return false;
      }
    },

    /* getConditionTotalPrice(condition: RentalConditionJson): number | null {
      if (this.details != null) {
        return getRentalBookingTotalPrice({ ...this.details, rentalCondition: condition }).priceIncludingVAT;
      }

      return null;
    }, */

    getConditionTotalPrice(condition: RentalConditionJson): number | null {
      if (this.details != null) {
        return getRentalConditionPrice(
          condition,
          this.details.amount,
          new Date(this.details.beginDate),
          new Date(this.details.endDate)
        );
      }

      return null;
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    details: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
          this.$emit("change", this.details);
        }
      },
      deep: true,
    },

    detailsBeginDate: {
      handler(val, oldVal) {
        if (val) {
          this.$emit('beginDateChange', val);
        }
      },
    },

    detailsEndDate: {
      handler(val, oldVal) {
        if (val) {
          this.$emit('endDateChange', val);
        }
      },
    },

    detailsRentalItem() {
      if (this.hasChanges) {
        this.resetBeginAndEnd();
        this.loadRentalItemInfo();
      }
    },

    detailsAmount: {
      handler(val, oldVal) {
        if (oldVal !== undefined) {
          this.resetBeginAndEnd();
          this.loadAvailabilities();
        }
      },
    },

    validation: {
      handler(val, oldVal) {
        if (oldVal !== undefined) {
          this.compValidation = this.validation;
        }
      },
    },

    editable() {
      this.currentCalendarDateIsSet = false;

      this.$nextTick(() => {
        this.showCurrentCalendarMonth();
      });
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    detailsRentalItem(): RentalItemJson | null | undefined {
      return this.details?.rentalItem;
    },

    detailsAmount(): number | null | undefined {
      return this.details?.amount;
    },

    detailsBeginDate(): string | null {
      return this.details ? this.details.beginDate : null;
    },

    detailsEndDate(): string | null {
      return this.details ? this.details.endDate : null;
    },

    rentalConditionsPriceNotOnRequest(): RentalConditionJson[] | null {
      if (this.availableConditions != null) {
        if (this.permissionAble) {
          return this.availableConditions;
        } else {
          let filtered = this.availableConditions.filter((i: RentalConditionJson) => {
            if (i.isOnRequestOnly || i.isManagementOnly) return false;
            return true;
          });

          return filtered.length > 0 ? filtered : [];
        }
      } else {
        return null;
      }
    },

    rentalConditionsFilteredByTypes(): RentalConditionJson[] | null {
      if (this.rentalConditionsPriceNotOnRequest != null) {
        return this.rentalConditionsPriceNotOnRequest.filter((rc: RentalConditionJson) => {
          if (
            rc.restrictToTypes == null ||
            (this.settings && this.settings.rentalShowAllConditionsIfUserPermissionAble && this.permissionAble)
          ) {
            return true;
          } else if (this.restrictToTypeId) {
            if (rc.restrictToTypes.find((t) => t.ID == this.restrictToTypeId)) return true;
          } else {
            if (this.clientData != null && this.clientData.types != null) {
              return this.clientData.types && this.clientData.types.length > 0
                ? rc.restrictToTypes.some((i: CategoryTypeJson) =>
                    this.clientData.types!.map((t: CategoryTypeJson) => t.ID).includes(i.ID)
                  )
                : false;
            } else {
              return false;
            }
          }
        });
      } else {
        return null;
      }
    },
  },
});
